import { Dropdown } from 'primeng/dropdown';

export const LOOKUP_UPLOAD_TYPE_PANEL_CLASS = 'lookup-upload-type-panel';

/** Repositions a PrimeNG dropdown panel to open above its trigger (for modal upload forms). */
export function flipLookupUploadDropdownAbove(dropdown: Dropdown | undefined | null): void {
  if (!dropdown?.el?.nativeElement) return;
  setTimeout(() => {
    const panel = document.querySelector(
      `.${LOOKUP_UPLOAD_TYPE_PANEL_CLASS}.p-dropdown-panel`
    ) as HTMLElement | null;
    const trigger = dropdown.el.nativeElement.querySelector('.p-dropdown') as HTMLElement | null;
    if (!panel || !trigger) return;
    const rect = trigger.getBoundingClientRect();
    const minPanelWidth = Math.max(rect.width, 320);
    const maxPanelWidth = Math.min(window.innerWidth * 0.9, 480);
    panel.style.setProperty('top', `${rect.top + window.scrollY - panel.offsetHeight}px`, 'important');
    panel.style.setProperty('left', `${rect.left + window.scrollX}px`, 'important');
    panel.style.setProperty('min-width', `${minPanelWidth}px`, 'important');
    panel.style.setProperty('max-width', `${maxPanelWidth}px`, 'important');
    panel.style.setProperty('width', 'max-content', 'important');
    panel.style.setProperty('transform', 'none', 'important');
  });
}
